import { useUserContext } from '@vp/ubik-context'

export const usePathname = (): string | undefined => {
  const { queryStrings = {}, forwardedPath } = useUserContext()

  return forwardedPath ?? queryStrings.forwardedPath ?? queryStrings.forwardedpath
}
